import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { RefundBaseComponent } from "./refund-base.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import * as _ from "lodash";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RefundActionTypeEnum } from "../../_models";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { RefundsFailReasons } from "./refund-fail-reasons/refunds-fail-reasons";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "refund-block",
  templateUrl: "refund-block.component.html",
  styleUrls: ["./refund-base.component.scss"],
})
export class RefundBlockComponent extends RefundBaseComponent {
  @Input() selectedItems: any;
  @Input() paymentItems: any;
  @Input() checkAll: boolean;
  @Input() filters: any;
  @ViewChild("result") resultContent: TemplateRef<any>;
  public modalReference: any;
  public resultObj: any;
  public dateNow: string = moment(Date.now()).format("YYYY-MM-DD HH:mm");
  public isPercentSelected = false;
  public percentAmountToggleTransform = "translateX(100%)";
  refundActionTypeEnum = RefundActionTypeEnum;
  public collectiveRefundSecondApproval: boolean;

  constructor(
    private modalService: NgbModal,
    public dataService: DataService,
    public alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
    this.collectiveRefundSecondApproval =
      this.sessionManager.features.CollectiveRefundSecondApproval;
  }

  run() {
    this.cashierStatuses = JSON.parse(localStorage.getItem("cashierStatuses"));
    if (this.base.user.hasRefundCode) {
      this.refundActionTypes.push(RefundActionTypeEnum.DENY);
      this.refundActionTypes.push(RefundActionTypeEnum.COMMENT);

      if (
        this.base.user.counties.filter((county) => county.name === "ALL")
          .length > 0
      ) {
        this.refundActionTypes.push(RefundActionTypeEnum.RENEW);
        if (this.collectiveRefundSecondApproval) {
          this.refundActionTypes.push(RefundActionTypeEnum.APPROVE);
        }
      } else {
        this.refundActionTypes.push(RefundActionTypeEnum.APPROVE);
      }
      this.formGroupObj = new FormGroup({
        comment: new FormControl(null, Validators.required),
        // note: new FormControl(null, Validators.required),
        action: new FormControl(null, Validators.required),
        amount: new FormControl(0, [
          Validators.required,
          Validators.max(100),
          Validators.min(0),
        ]),
      });
    } else {
      this.refundActionTypes.push(RefundActionTypeEnum.COMMENT);
      this.formGroupObj = new FormGroup({
        comment: new FormControl(null, Validators.required),
        amount: new FormControl(0, [
          Validators.required,
          Validators.max(50000),
          Validators.min(0),
        ]),
        action: new FormControl(null, Validators.required),
      });
    }
  }

  getFormattedConfirmationText() {
    const numberOfChildren = this.selectedItems.length;
    let totalAmount = 0;
    if (this.formGroupObj.contains("percent")) {
      const percent = this.formGroupObj.getRawValue()["percent"];
      this.paymentItems.forEach((item) => {
        if (this.selectedItems.includes(item.id)) {
          totalAmount += Math.round(item.finalPrice * (0.01 * percent));
        }
      });
      return this.base.messages.payment_return_admin_percent_message
        .replace("$1$", percent)
        .replace("$2$", numberOfChildren)
        .replace("$3$", totalAmount);
    } else {
      const amount = this.formGroupObj.getRawValue()["amount"];
      totalAmount = numberOfChildren * amount;
      return this.base.messages.payment_return_admin_amount_message
        .replace("$1$", amount)
        .replace("$2$", numberOfChildren)
        .replace("$3$", totalAmount);
    }
  }

  getFormattedRefundNumberText() {
    if (this.selectedItems.length > 1) {
      return this.base.messages.payment_collective_return_numders_of_children.replace(
        "$1$",
        this.selectedItems.length
      );
    } else {
      return this.base.messages.payment_collective_return_one_child;
    }
  }

  public getDetailedFailReason(failReason: string) {
    return RefundsFailReasons(failReason);
  }

  public openModal(content) {
    if (this.modalReference) {
      this.modalReference.close();
    }
    const options: NgbModalOptions = {
      windowClass: "refund-multiple",
      backdrop: "static",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  openModalResult(content) {
    if (this.modalReference) {
      this.modalReference.close();
    }
    const options: NgbModalOptions = {
      windowClass: "refund-multiple",
      backdrop: "static",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  confirmRefund(content) {
    if (
      this.formGroupObj.get("action").value === RefundActionTypeEnum.COMMENT
    ) {
      this.confirm();
    } else {
      this.formGroupConfirmObj = new FormGroup({
        refundAdminCode: new FormControl(null, Validators.required),
        cancelParticipation: new FormControl(false, Validators.required),
      });
      this.openModal(content);
    }
  }

  confirm() {
    this.errorMessage = undefined;
    if (!this.loading) {
      this.loading = true;
      const postData = _.merge(
        {},
        this.formGroupObj.getRawValue(),
        this.formGroupConfirmObj ? this.formGroupConfirmObj.getRawValue() : {},
        { paymentItemIds: this.selectedItems }
      );

      this.dataService
        .postEntity("payments/collective-refund", postData)
        .subscribe(
          (data) => {
            this.loading = false;
            this.resultObj = data;
            this.clearFormObj();
            this.openModal(this.resultContent);
          },
          (error) => {
            this.loading = false;
            const body = error.json && error.json();
            const message =
              (body &&
                body.statusText &&
                this.base.messages[body.statusText]) ||
              this.base.messages["refund_error_general"];

            this.alertService.error(message);
          }
        );
    }
  }

  togglePercentAmount() {
    this.isPercentSelected = !this.isPercentSelected;
    if (this.isPercentSelected) {
      this.percentAmountToggleTransform = "translateX(0)";
      this.formGroupObj.addControl(
        "percent",
        new FormControl(this.formGroupObj.get("amount").value, [
          Validators.required,
          Validators.max(100),
          Validators.min(0),
        ])
      );
      this.formGroupObj.removeControl("amount");
    } else {
      this.percentAmountToggleTransform = "translateX(100%)";
      this.formGroupObj.addControl(
        "amount",
        new FormControl(this.formGroupObj.get("percent").value, [
          Validators.required,
          Validators.max(50000),
          Validators.min(0),
        ])
      );
      this.formGroupObj.removeControl("percent");
    }
  }

  closeRefundModal(
    closeParams: string,
    isClearForm: boolean,
    isRefundComplete: boolean,
    openModal: TemplateRef<any>
  ) {
    this.modalReference.close(closeParams);
    if (isClearForm) {
      this.clearFormObj();
    }
    if (isRefundComplete) {
      this.onRefundCompleted.emit();
    }
    if (openModal) {
      this.openModal(openModal);
    }
  }

  log(e) {
    console.info(e);
    return true;
  }

  isGizbarMaagalOrUp() {
    return this.sessionManager.getUserPermissions(this.base.user)
      .gizbarMaagalOrUp;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/payments_refunds/refund-block.component.ts